/* eslint-disable react/destructuring-assignment */
import React, {
  InputHTMLAttributes,
  useState,
  useRef,
  ReactNode,
  useEffect,
} from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  Button,
  withStyles,
  ButtonProps,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import { PlainText } from 'components/MasterGrids/MasterGrids';

// style----------------------------------------------------
export const StyleFormControl = withStyles(() => ({
  root: {
    padding: '5px',
  },
}))(FormControl);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      padding: '6px 16px',
      fontSize: '0.875rem',
      minWidth: '64px',
      boxSizing: 'border-box',
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      fontFamily: " 'Helvetica', 'Arial', sans-serif",
      fontWeight: 500,
      lineHeight: 1.75,
      borderRadius: '4px',
      letterSpacing: '0.02857em',
      textTransform: 'uppercase',
      boxShadow:
        '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        boxShadow:
          '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
      },
    },
  })
);

export const StyledSpanButton = (props: { text: string }): JSX.Element => {
  const { text } = props;
  const classes = useStyles();
  return <span className={classes.root}>{text} </span>;
};

export const StyleFormHelperText = withStyles(() => ({
  root: {
    margin: '5px 14px 0',
  },
}))(FormHelperText);

// interface----------------------------------------------------
interface IFileUpload extends InputHTMLAttributes<HTMLInputElement> {
  fileTemp: [File | null, (File: File) => void];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputRef?: any;
  // inputRef?: MutableRefObject<HTMLInputElement>,

  verifyBeforeChange?: boolean;
  verifiers?: IVerifier[];
  error?: boolean;
  helperText?: ReactNode;
}

interface IVerifier {
  func: (value: unknown) => boolean;
  text: string;
}

export const FileUpload = (props: IFileUpload): JSX.Element => {
  const {
    inputRef = useRef(),
    verifyBeforeChange = false,
    error,
    helperText,
    verifiers = [],
    fileTemp,
    accept = '.xls,.xlsx',
    ...other
  } = props;
  const [file, setFile] = fileTemp;
  const [message, setMessage] = useState('');
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage('');
      return;
    }

    // 驗 HTML validation
    if (inputRef.current && inputRef.current.validationMessage.length > 0) {
      setMessage(inputRef.current.validationMessage);
      return;
    }

    // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
    if (props.value && verifiers.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const obj of verifiers) {
        if (obj.func(props.value)) {
          setMessage(obj.text);
          return;
        }
      }
    }

    // 先前檢驗都 pass
    setMessage('');
  }, [file, verifyBeforeChange]);

  return (
    <StyleFormControl error={error || message.length > 0}>
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <StyledSpanButton text="檔案上傳" />
        <input
          type="file"
          accept={accept}
          ref={inputRef}
          hidden
          onChange={(e) => setFile((e.target.files || [])[0])}
          {...other}
        />
        <PlainText>{!file ? '請選擇檔案...' : file.name}</PlainText>
      </label>
      <StyleFormHelperText>{helperText || message}</StyleFormHelperText>
    </StyleFormControl>
  );
};

const StyleButton = withStyles({
  root: {
    borderRadius: '20px',
  },
})(Button);
type IStyleButton = ButtonProps;
export const ButtonContain = (props: IStyleButton): JSX.Element => {
  const { children, ...other } = props;
  return (
    <StyleButton variant="contained" color="primary" {...other}>
      {children}
    </StyleButton>
  );
};
export const ButtonContainO = (props: IStyleButton): JSX.Element => {
  const { children, ...other } = props;
  return (
    <Button variant="contained" color="primary" {...other}>
      {children}
    </Button>
  );
};
export const ButtonOutline = (props: IStyleButton): JSX.Element => {
  const { children, ...other } = props;
  return (
    <Button variant="outlined" color="primary" {...other}>
      {children}
    </Button>
  );
};
